<div class="auth-layout" [attr.dir]="pageLayout.layout">
  <!-- Form panel -->
  <section class="auth-panel">
    <!-- Mobile visual strip -->
    <div class="auth-mobile-strip">
      <a class="auth-mobile-strip__brand" routerLink="/start">
        <ui-jct-logo [solid]="true" [includePadding]="false" [width]="40"></ui-jct-logo>
        <div>
          <p class="auth-mobile-strip__title" i18n>המרכז האקדמי לב</p>
          <p class="auth-mobile-strip__subtitle" i18n>מערכת הרישום</p>
        </div>
      </a>
    </div>

    <!-- Desktop header -->
    <header class="auth-panel__header">
      <a class="auth-panel__brand" routerLink="/start">
        <img
          class="auth-brand-logo"
          src="/assets/images/jct-logo.png"
          width="36"
          height="36"
          alt=""
          aria-hidden="true"
        />
        <span i18n>המרכז האקדמי לב</span>
      </a>

      <div class="auth-panel__top-actions">
        <language-menu *ngIf="l10n.enabled"></language-menu>
        <a class="auth-support-link" routerLink="/contact" routerLinkActive="is-active">
          <mat-icon>phone</mat-icon>
          <span i18n>יצירת קשר</span>
        </a>
      </div>
    </header>

    <!-- Main form area -->
    <main class="auth-panel__main">
      <div class="auth-panel__content">
        <div class="auth-panel__form">
          <ng-content></ng-content>
        </div>
      </div>
    </main>

    <section class="auth-quick-actions">
      <div class="auth-quick-actions__grid">
        <a
          class="auth-quick-action"
          *ngIf="showLoginAction"
          routerLink="/start"
          routerLinkActive="is-active"
          [routerLinkActiveOptions]="{ exact: false }"
        >
          <mat-icon>login</mat-icon>
          <span i18n>כניסה למערכת</span>
        </a>
        <a
          class="auth-quick-action"
          href="https://www.jct.ac.il/guide/2025-26/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <mat-icon>menu_book</mat-icon>
          <span i18n>מדריך לנרשם</span>
        </a>
        <a class="auth-quick-action" *ngIf="showCalculatorAction" routerLink="/calculator" routerLinkActive="is-active">
          <mat-icon>calculate</mat-icon>
          <span i18n>מחשבון ציון התאמה</span>
        </a>
      </div>
    </section>

    <footer class="auth-panel__footer">
      <span i18n>© {{ year }} המרכז האקדמי לב. כל הזכויות שמורות.</span>
    </footer>
  </section>

  <!-- Visual panel (desktop) -->
  <aside class="auth-visual">
    <div class="auth-visual__glow auth-visual__glow--top" aria-hidden="true"></div>
    <div class="auth-visual__glow auth-visual__glow--bottom" aria-hidden="true"></div>

    <svg
      class="auth-visual__geometry"
      preserveAspectRatio="xMidYMid slice"
      viewBox="0 0 600 800"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <circle cx="485" cy="155" r="115" stroke="rgba(255,255,255,0.07)" stroke-width="1" />
      <circle cx="485" cy="155" r="175" stroke="rgba(255,255,255,0.045)" stroke-width="1" />
      <circle cx="485" cy="155" r="235" stroke="rgba(255,255,255,0.025)" stroke-width="1" />
      <circle cx="75" cy="650" r="95" stroke="rgba(255,255,255,0.055)" stroke-width="1" />
      <circle cx="75" cy="650" r="155" stroke="rgba(255,255,255,0.03)" stroke-width="1" />
      <circle cx="520" cy="685" r="75" fill="rgba(58,175,201,0.08)" />
      <circle cx="520" cy="685" r="38" fill="rgba(58,175,201,0.13)" />
      <circle cx="400" cy="425" r="3" fill="rgba(58,175,201,0.55)" />
      <circle cx="442" cy="385" r="2.5" fill="rgba(255,255,255,0.4)" />
      <circle cx="378" cy="470" r="2" fill="rgba(255,255,255,0.3)" />
      <circle cx="465" cy="445" r="2.5" fill="rgba(255,255,255,0.35)" />
      <line x1="400" y1="425" x2="442" y2="385" stroke="rgba(255,255,255,0.08)" stroke-width="1" />
      <line x1="400" y1="425" x2="378" y2="470" stroke="rgba(255,255,255,0.06)" stroke-width="1" />
      <line x1="400" y1="425" x2="465" y2="445" stroke="rgba(255,255,255,0.07)" stroke-width="1" />
    </svg>

    <div class="auth-visual__brand">
      <div class="auth-visual__brand-row">
        <ui-jct-logo [solid]="true" [includePadding]="false" [width]="56"></ui-jct-logo>
        <div>
          <p class="auth-visual__brand-title" i18n>המרכז האקדמי לב</p>
          <p class="auth-visual__brand-subtitle" i18n>למצוינות בהשכלה גבוהה</p>
        </div>
      </div>
    </div>

    <div class="auth-visual__hero">
      <h2 i18n>
        הצעד הראשון
        <br />
        למסע האקדמי שלכם
      </h2>
      <p i18n>
        הרשמו למרכז האקדמי לב ותתחילו את הדרך שלכם.
        <br />
        תהליך הרישום פשוט, מהיר ומלווה בצוות קבלה מסור.
      </p>
    </div>

    <div class="auth-visual__features">
      <div class="auth-visual__feature">
        <div class="auth-visual__feature-icon">
          <mat-icon>assignment</mat-icon>
        </div>
        <span i18n>הגשת בקשת רישום בצורה פשוטה ומהירה</span>
      </div>
      <div class="auth-visual__feature">
        <div class="auth-visual__feature-icon">
          <mat-icon>schedule</mat-icon>
        </div>
        <span i18n>מעקב אחר סטטוס המועמדות שלכם</span>
      </div>
      <div class="auth-visual__feature">
        <div class="auth-visual__feature-icon">
          <mat-icon>verified_user</mat-icon>
        </div>
        <span i18n>תהליך מאובטח ומוגן לחלוטין</span>
      </div>
    </div>
  </aside>
</div>
